<section class="w-full bg-gray-50 py-6">

  <!-- Modal -->
  <div id="modal-overlay" class="fixed inset-0 bg-black bg-opacity-40 items-center justify-center z-50 hidden"
    (click)="handleOverlayClick($event)">
    <div id="modal"
      class="bg-white w-[95%] max-w-sm rounded-2xl overflow-hidden shadow-2xl animate-fade-in scale-100 transition-all duration-300 pointer-events-auto"
      (click)="$event.stopPropagation()">

      <div class="grid grid-cols-1">
        <div class="relative bg-white p-10 pt-16 flex flex-col items-center justify-center gap-6 min-h-[300px]">
          <!-- Header fijo (logo + X) -->
          <div class="absolute top-0 left-0 w-full flex items-center justify-between p-8 bg-white">
            <img
              src="https://api-upgraded.myskillcamp.com.deltabluecdn.com/api/stockage/image/cf31e90c-2b5f-5ea1-b598-e907f10e0a83.png?size=512"
              alt="CompanyName" class="h-8 w-auto max-w-full object-contain">
            <button (click)="closeModal()" class="text-gray-500 hover:text-gray-700 text-lg">✖</button>
          </div>

          <!-- Contenido centrado -->
          <div class="flex flex-col items-center justify-center text-center">

            <!-- Botones con tooltip -->
            <div class="absolute top-20 right-4 flex flex-col gap-3 pr-2">
              <!-- Compartir -->
              <div class="group relative flex items-center">
                <button
                  class="backdrop-blur-sm bg-white/10 border border-gray-300 px-2 py-1 rounded-full hover:bg-white/20 transition-all">
                  <i class="icon icon-share text-gray-500 hover:text-gray-700 text-md  transition"></i>
                </button>
                <div
                  class="absolute right-full mr-2 bg-gray-800 text-white text-xs rounded-[8px]  z-10 px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap ">
                  {{'words.share' | translate}}
                </div>
              </div>

              <!-- Descargar -->
              <div class="group relative flex items-center">
                <button
                  class="backdrop-blur-sm bg-white/10 border border-gray-300 px-2 py-1 rounded-full hover:bg-white/20 transition-all">
                  <i class="icon icon-download text-gray-500 hover:text-gray-700  text-md transition"></i>
                </button>
                <div
                  class="absolute right-full mr-2 bg-gray-800 text-white text-xs rounded-[8px]  z-10 px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap  ">
                  {{'common.download' | translate}}
                </div>
              </div>
            </div>

            <!-- Imagen con glow -->
            <div class="relative w-fit">
              <div class="absolute inset-0 z-0 pointer-events-none">
                <div class="w-full h-full bg-white blur-2xl rounded-2xl"
                  style="animation: wave-glow 6s ease-in-out infinite;"></div>
              </div>
              <div class="floating-group">
                <div class="floating-container">
                  <img src="../../assets/badges/pack-02/01.png"
                    class="floating-image relative  min-w-[140px] max-w-[180px] h-48 object-contain z-0 drop-shadow-[0_0_25px_rgba(255,255,255,0.8)]">
                </div>
              </div>
            </div>

            <!-- Barra de progreso -->
            <div class="hidden w-full max-w-[300px] items-center gap-3 my-2">
              <div class="flex-1">
                <div class="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div class="h-2 bg-progress-gradient w-2/3 rounded-full transition-all duration-300"></div>
                </div>
              </div>
              <span class="text-sm text-gray-600 whitespace-nowrap">100%</span>
            </div>
            <!-- Texto -->
            <h2 class="text-lg font-semibold text-gray-700 mt-2 mb-4">{{ 'academy.badge-name' | translate }}</h2>
            <p class="text-gray-700 text-sm">
              "¡Bien hecho! Solo te falta un 20% para obtener tu insignia de <b>Explorador de conocimiento</b>."
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- section principal -->
  <section
    class="bg-white card-academy rounded-[14px] p-6 relative z-10  my-4 w-full mx-auto max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]">
    <!-- head -->
    <section class=" card-course-grid  flex flex-col h-auto ">
      <!-- Flecha y buscador -->
      <div class="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
        <!-- Flecha atras -->
        <button class="btn-primary bg-white rounded-full shadow-md gap-4 cursor-pointer" (click)="goBack()">
          <i class="fa-solid fa-chevron-left w-5 h-5 text-gray-400 items-center flex"></i>
          <h2 class="text-xl font-semibold cursor-auto">{{'words.badges' | translate}}</h2>
        </button>

        <!-- Buscador -->
        <div
          class="bg-white rounded-[10px] px-1 flex items-center w-full md:w-72  md:mt-0  border-[1px] shadow-sm border-gray-200">
          <input type="text" [placeholder]="'words.search-badge' | translate"
            class="flex-grow p-2 focus:outline-none font-[400] rounded-[10px] text-sm"
            (ngModelChange)="search(searchTerm)" [(ngModel)]="searchTerm" />
          <button class="bg-white p-2 rounded-r-lg">
            <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
          </button>
        </div>
      </div>
    </section>

    <!-- Cards -->
    <div class="min-h-screen flex flex-col">
      <section class="py-4 card-course-grid flex-grow w-full">
        <!-- Grid de 5 columnas -->
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 xxl:grid-cols-6 xxxl:grid-cols-6 3xl:grid-cols-6 4xl:grid-cols-8 gap-5 p-6">
          <!-- Card -->

          <!-- card COMPLETA de porcentaje -->
          <div
            class="rounded-[14px] overflow-y-auto card-shadow-2 border border-gray-100 p-6 cursor-pointer hover:shadow-xl transition-all duration-300"
            (click)="openModal()">
            <!-- Header: Título + ícono descarga -->
            <div class="flex justify-between items-center h-12 ">
              <h3 class="text-base font-semibold text-gray-700 line-clamp-2">{{ 'academy.badge-level-explorer' | translate }}</h3>
              <button [title]="'common.download' | translate">
                <i class="icon icon-download text-gray-500 hover:text-gray-700 text-xl"></i>
              </button>
            </div>

            <!-- Imagen -->
            <div class="flex justify-center my-1 ">
              <div class="relative inline-block w-[120px] h-32">
                <img src="../../assets/badges/pack-02/01.png" class="img-badge w-full h-full object-contain" />


              </div>
            </div>

            <!-- Texto de 3 líneas con puntos suspensivos y fondo gray -->
            <div class="bg-gray-50 rounded-t-[14px] -m-6 mt-0 px-6 pt-4 pb-6">
              <!-- Texto -->
              <p class="text-sm text-gray-600 line-clamp-3 leading-snug mb-4">
                Este certificado valida que el usuario completó satisfactoriamente el curso avanzado de nutrición
                animal, obteniendo las competencias necesarias para implementar planes de alimentación saludables y
                efectivos
                en diferentes especies...
              </p>
              <!-- Barra de progreso con porcentaje -->
              <div class="flex items-center gap-2 h-5">
                <div class="w-full">
                  <div class="w-full h-2 bg-gray-200 rounded-[14px]">
                    <div class="h-2 bg-green-500 w-100 rounded-[14px]"></div>
                  </div>
                </div>
                <span class="text-sm text-gray-500 hidden">100%</span>
                <i class="icon icon-checkmark-circle text-green-500 text-lg"></i>
              </div>
            </div>
          </div>

          <div
            class="rounded-[14px] overflow-y-auto card-shadow-2 border border-gray-100 p-6 cursor-pointer hover:shadow-xl transition-all duration-300"
            (click)="openModal()">
            <!-- Header: Título + ícono descarga -->
            <div class="flex justify-between items-center h-12 ">
              <h3 class="text-base font-semibold text-gray-700 line-clamp-2">{{ 'academy.badge-level-explorer' | translate }}</h3>
              <button [title]="'common.download' | translate">
                <i class="icon icon-download text-gray-500 hover:text-gray-700 text-xl"></i>
              </button>
            </div>

            <!-- Imagen -->
            <div class="flex justify-center my-1">
              <div class="relative inline-block w-[120px] h-32">
                <img src="../../assets/badges/pack-02/02.png" class="img-badge w-full h-full object-contain  " />

              </div>
            </div>

            <!-- Texto de 3 líneas con puntos suspensivos y fondo gray -->
            <div class="bg-gray-50 rounded-t-[14px] -m-6 mt-0 px-6 pt-4 pb-6">
              <!-- Texto -->
              <p class="text-sm text-gray-600 line-clamp-3 leading-snug mb-4">
                Este certificado valida que el usuario completó satisfactoriamente el curso avanzado de nutrición
                animal, obteniendo las competencias necesarias para implementar planes de alimentación saludables y
                efectivos
                en diferentes especies...
              </p>
              <!-- Barra de progreso con porcentaje -->
              <div class="flex items-center gap-2 h-5">
                <div class="w-full">
                  <div class="w-full h-2 bg-gray-200 rounded-[14px]">
                    <div class="h-2 bg-green-500 w-100 rounded-[14px]"></div>
                  </div>
                </div>
                <span class="text-sm text-gray-500 hidden">100%</span>
                <i class="icon icon-checkmark-circle text-green-500 text-lg"></i>
              </div>
            </div>

          </div>

          <div
            class="rounded-[14px] overflow-y-auto card-shadow-2 border border-gray-100 p-6 cursor-pointer hover:shadow-xl transition-all duration-300"
            (click)="openModal()">
            <!-- Header: Título + ícono descarga -->
            <div class="flex justify-between items-center h-12 ">
              <h3 class="text-base font-semibold text-gray-700 line-clamp-2">{{ 'academy.badge-level-explorer' | translate }}</h3>
              <button [title]="'common.download' | translate">
                <i class="icon icon-download text-gray-500 hover:text-gray-700 text-xl"></i>
              </button>
            </div>

            <!-- Imagen -->
            <div class="flex justify-center my-1 ">
              <div class="relative inline-block w-[120px] h-32">
                <img src="../../assets/badges/pack-02/03.png"
                  class="img-badge img-badge w-full h-full object-contain  " />
              </div>
            </div>
            <!-- Texto de 3 líneas con puntos suspensivos y fondo gray -->
            <div class="bg-gray-50 rounded-t-[14px] -m-6 mt-0 px-6 pt-4 pb-6">
              <!-- Texto -->
              <p class="text-sm text-gray-600 line-clamp-3 leading-snug mb-4">
                Este certificado valida que el usuario completó satisfactoriamente el curso avanzado de nutrición
                animal,
                obteniendo las competencias necesarias para implementar planes de alimentación saludables y efectivos
                en
                diferentes especies...
              </p>

              <!-- Barra de progreso con porcentaje -->
              <div class="flex items-center gap-2 h-5">
                <div class="w-full">
                  <div class="w-full h-2 bg-gray-200 rounded-[14px]">
                    <div class="h-2 bg-green-500 w-100 rounded-[14px]"></div>
                  </div>
                </div>
                <span class="text-sm text-gray-500 hidden">100%</span>
                <i class="icon icon-checkmark-circle text-green-500 text-lg"></i>
              </div>
            </div>

          </div>

          <div
            class="rounded-[14px] overflow-y-auto card-shadow-2 border border-gray-100 p-6 cursor-pointer hover:shadow-xl transition-all duration-300"
            (click)="openModal()">
            <!-- Header: Título + ícono descarga -->
            <div class="flex justify-between items-center h-12 ">
              <h3 class="text-base font-semibold text-gray-700 line-clamp-2">{{ 'academy.badge-level-explorer' | translate }}</h3>
              <button [title]="'common.download' | translate">
                <i class="icon icon-download text-gray-500 hover:text-gray-700 text-xl"></i>
              </button>
            </div>


            <!-- Imagen -->
            <div class="flex justify-center my-1 ">
              <div class="relative inline-block w-[120px] h-32">
                <img src="../../assets/badges/pack-02/04.png" class="img-badge w-full h-full object-contain  " />
              </div>
            </div>

            <!-- Texto de 3 líneas con puntos suspensivos y fondo gray -->
            <div class="bg-gray-50 rounded-t-[14px] -m-6 mt-0 px-6 pt-4 pb-6">
              <!-- Texto -->
              <p class="text-sm text-gray-600 line-clamp-3 leading-snug mb-4">
                Este certificado valida que el usuario completó satisfactoriamente el curso avanzado de nutrición
                animal,
                obteniendo las competencias necesarias para implementar planes de alimentación saludables y efectivos
                en
                diferentes especies...
              </p>

              <!-- Barra de progreso con porcentaje -->
              <div class="flex items-center gap-2 h-5">
                <div class="w-full">
                  <div class="w-full h-2 bg-gray-200 rounded-[14px]">
                    <div class="h-2 bg-green-500 w-100 rounded-[14px]"></div>
                  </div>
                </div>
                <span class="text-sm text-gray-500 hidden">100%</span>
                <i class="icon icon-checkmark-circle text-green-500 text-lg"></i>
              </div>
            </div>
          </div>

          <!-- card INCOMPLETA de porcentaje -->
          <div
            class="rounded-[14px] overflow-y-auto card-shadow-2 border border-gray-100 p-6 cursor-not-allowed pointer-events-none  transition-all duration-300"
            (click)="openModal()">
            <!-- Header: Título + ícono descarga -->
            <div class="flex justify-between items-center h-12 ">
              <h3 class="text-base font-semibold text-gray-700 line-clamp-2">{{ 'academy.badge-level-explorer' | translate }}</h3>
              <button [title]="'common.download' | translate">
                <i class="icon icon-download text-gray-500 hover:text-gray-700 text-xl"></i>
              </button>
            </div>

            <!-- Imagen -->
            <div class="flex justify-center my-1 ">
              <div class="relative inline-block w-[120px] h-32">
                <img src="../../assets/badges/pack-02/05.png" class="img-badge w-full h-full object-contain  " />

              </div>
            </div>

            <!-- Texto de 3 líneas con puntos suspensivos y fondo gray -->
            <div class="bg-gray-50 rounded-t-[14px] -m-6 mt-0 px-6 pt-4 pb-6">
              <!-- Texto -->
              <p class="text-sm text-gray-600 line-clamp-3 leading-snug mb-4">
                Este certificado valida que el usuario completó satisfactoriamente el curso avanzado de nutrición
                animal,
                obteniendo las competencias necesarias para implementar planes de alimentación saludables y efectivos
                en
                diferentes especies...
              </p>

              <!-- Barra de progreso con porcentaje -->
              <div class="flex items-center gap-2 h-5">
                <div class="w-full">
                  <div class="w-full h-2 bg-gray-200 rounded-[14px]">
                    <div class="h-2 bg-progress-gradient w-2/3 rounded-[14px]"></div>
                  </div>
                </div>
                <span class="text-sm text-gray-500">60%</span>
              </div>
            </div>

          </div>

          <!-- card BLOQUEADA -->
          <div
            class="rounded-[14px] overflow-hidden card-academy border border-gray-100 p-6  cursor-not-allowed pointer-events-none transition-all duration-300 ">
            <!-- Header: Título + ícono candado -->
            <div class="flex justify-between items-center h-12 ">
              <h3 class="text-base font-semibold text-gray-700 line-clamp-2">
                {{ 'academy.badge-level-explorer' | translate }}
              </h3>
              <div [title]="'words.locked' | translate">
                <svg xmlns="http://www.w3.org/2000/svg" class="hover:text-gray-700 text-gray-400" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 15v2m6 4H6a2 2 0 01-2-2v-6a2 2 0 012-2h12a2 2 0 012 2v6a2 2 0 01-2 2zM16 7a4 4 0 00-8 0v4h8V7z" />
                </svg>
              </div>
            </div>


            <!-- Imagen -->
            <div class="flex justify-center my-1 opacity-30">
              <div class="relative inline-block w-[120px] h-32">
                <img src="../../assets/badges/pack-02/06.png" class="img-badge w-full h-full object-contain  " />


              </div>
            </div>



            <!-- Texto con fondo gray-50 -->
            <div class="bg-gray-50 rounded-t-[14px] -m-6 mt-0 px-6 pt-4 pb-6">
              <p class="text-sm text-gray-600 line-clamp-3 leading-snug mb-4">
                Este certificado valida que el usuario completó satisfactoriamente el curso avanzado de nutrición
                animal,
                obteniendo las competencias necesarias para implementar planes de alimentación saludables y efectivos
                en
                diferentes especies...
              </p>

              <!-- Barra de progreso (oculta) -->
              <div class="hidden items-center gap-2">
                <div class="w-full">
                  <div class="w-full h-2 bg-gray-200 rounded-[14px]">
                    <div class="h-2 bg-progress-gradient w-2/3 rounded-[14px]"></div>
                  </div>
                </div>
                <span class="text-sm text-gray-500">100%</span>
              </div>
            </div>
          </div>



          <!-- Paginador  -->
          <div class="col-span-full flex justify-end py-4">
            <div class="inline-flex gap-2 text-sm justify-end">
              <button class="px-2 py-1  text-gray-700 "><i
                  class="fa-solid fa-chevron-left w-5 h-5 text-gray-400 items-center flex"></i></button>
              <button class="px-2 py-1  text-gray-700  hover:text-primary">1</button>
              <button class="px-2 py-1  text-gray-700  hover:text-primary">2</button>
              <button class="px-2 py-1  text-gray-700  hover:text-primary">3</button>
              <button class=" px-2 py-1  text-gray-700 hover:text-primary "><i
                  class="fa-solid fa-chevron-right w-5 h-5 text-gray-400 items-center flex"></i></button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</section>